import { render, staticRenderFns } from "./VMapBox.vue?vue&type=template&id=272d5a84"
import script from "./VMapBox.vue?vue&type=script&lang=js"
export * from "./VMapBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('272d5a84')) {
      api.createRecord('272d5a84', component.options)
    } else {
      api.reload('272d5a84', component.options)
    }
    module.hot.accept("./VMapBox.vue?vue&type=template&id=272d5a84", function () {
      api.rerender('272d5a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commons/VMapBox.vue"
export default component.exports